import firebase from "firebase";

const config = {
    apiKey: "VPmmrj4BJLsMrsYu7pauWC4QfT9zq4Kjv6nCO0M8",
    authDomain: "https://spoti-stats.firebaseapp.com/",
    projectId: "spoti-stats",
    databaseURL: "https://spoti-stats.firebaseio.com/",
    storageBucket: "spoti-stats.appspot.com",

}

firebase.initializeApp(config)
const database = firebase.database()
export default database;